module.exports = __webpack_public_path__ + "static/media/logo1.c9cfa8c2.png";